var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 7.83333V11.8333M9.33341 7.83333V11.8333M2.66675 5.16667H13.3334M12.6667 5.16667L12.0887 13.2613C12.0648 13.5977 11.9143 13.9125 11.6675 14.1424C11.4207 14.3722 11.096 14.5 10.7587 14.5H5.24141C4.90417 14.5 4.57946 14.3722 4.33267 14.1424C4.08588 13.9125 3.93536 13.5977 3.91141 13.2613L3.33341 5.16667H12.6667ZM10.0001 5.16667V3.16667C10.0001 2.98986 9.92984 2.82029 9.80482 2.69526C9.6798 2.57024 9.51023 2.5 9.33341 2.5H6.66675C6.48994 2.5 6.32037 2.57024 6.19534 2.69526C6.07032 2.82029 6.00008 2.98986 6.00008 3.16667V5.16667H10.0001Z",
    stroke: "#FF3B30",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5741c31f1d5d3ed5dcb7f6160993d1e2.svg";
export { ForwardRef as ReactComponent };